import { merge } from 'lodash-es'
import actions from './actions'
import { _isMobile, _isApp } from '@/utils'

const isH5View = !!_isMobile() || !!_isApp()
const forumSettings = {
  layer1: {
    1: { txt: 'DU圈', sort:'1', info: { name: 'DU圈', desc: '', hotBoardOption: 'duhot' }},
    2: { txt: '老哥', sort:'2', info: { name: '老哥圈', desc: '随时随地，来一发：分享场子，路子，妹子，<br/>票子那些事', hotBoardOption: 'hot' }},
    3: { txt: '老姐', sort:'3', info: { name: '老姐圈', desc: '老姐聚，好情趣，不止聊，还有料，想撩就撩', hotBoardOption: 'shot' }},
    4: { txt: '大赢家', sort:'5', info: { name: '大赢家', desc: '本圈由尊龙凯时独家赞助', hotBoardOption: 'bhot' }},
    // 5: { txt: '世界杯', sort:'4', h5keep:true, info: { name: '世界杯', desc: '上场，第一次进攻，全攻全守，突破，世界杯<br/>精彩时刻，尽在抖圈', hotBoardOption: 'sportshot' }},
  },
  // layer2 新增時要增加fid，fid>0才會有管理員工具
  layer2: {
    // 1
    11: { txt: '推荐', apiParams: isH5View ? { option: 'tuijian', switch:'all' } : { option: 'tuijian' }, maxPage: isH5View ? 8 : 1 ,meta: { 'memo2023':'推荐-全部' }}, // h5: 上限 150 笔, pc: 上限 20 笔, 每页固定 20 笔
    12: { txt: '关注', apiParams: { option: 'follow' }, requireLogin: true ,meta: { 'memo2023':'关注' }},
    13: { txt: '全部', apiParams: { option: 'all' }},
    // 2
    21: { txt: '热门', fid:56, apiParams: { option: 'hot' }},
    22: { txt: '最新', fid:56, apiParams: isH5View? { option: 'tuijian', switch:'b_tuijan' } : { option: 'bnew' } ,meta: { 'memo2023':'推荐-老哥' }},
    23: { txt: '老哥修车', fid:52, apiParams: { option: 'sex' }},
    24: { txt: '精华', fid:56, apiParams: { option: 'bdigest' }},
    // 3
    31: { txt: '热门', fid:62, apiParams: { option: 'sdigest' }},
    32: { txt: '最新', fid:62, apiParams: isH5View? { option: 'tuijian', switch:'s_tuijan' } : { option: 'snew' },meta: { 'memo2023':'推荐-老姐' }},
    // 4
    41: { txt: '活动', fid:43, apiParams: isH5View? { option: 'tuijian', switch:'official_tuijan' } : { option: 'activity' }, meta: { 'memo2023':'推荐-官方' }},
    42: { txt: '赌神', fid:42, apiParams: { option: 'dugod' }},
    43: { txt: '品牌', fid:63, apiParams: { option: 'brand' }},
    44: { txt: '全部', fid:41, apiParams: { option: 'offical_all' }},
    // 5
    // 51: { txt: '世界杯', fid:59, apiParams: { option: 'sports' }},
    61: { txt: '杂谈', fid:64, apiParams: { option: 'tuijian', switch:'gossip_tuijan' },meta: { 'memo2023':'推荐-杂谈' }},
    62: { txt: '爆奖', fid:65, apiParams: { option: 'tuijian', switch:'bp_tuijan' },meta: { 'memo2023':'推荐-爆奖' }},
    63: { txt: '热榜', meta: { 'memo2023':'热榜' }}
  }
}
const selectedForumDefault = '11'
const forumListDataDefault = {
  target: '11',
  list: [],
  topList: [], // 置顶列表 for PC
  pageSize: 20, // 一页几笔
  total: 0, // 总笔数
  page: 1, // 第几页
  pages: 1, // 总页数
  scrollTop: 0 // 上一次离开页面时的卷轴位置
}

const state = {
  selectedForumDefault,
  selectedForum: selectedForumDefault,
  forumSettings: forumSettings,
  forumListDataDefault,
  forumListData: forumListDataDefault,
  hotBoardListData: [],
  isUpdateDataOnRouter: 0,
  // -1: 不要触发 router 以下行为 <-- 画面操作
  // 0: 在 router 检查 query params --> 2
  // 1: 在 router 触发 call api
  routerFailRecallCount: 0, // 计数 recall 次数 ( avoid recall loop )
  isListDataLoading: false
}

const getters = {
  selectedForumLayer1(state) {
    return state.selectedForum.toString()[0]
  },
  formSelectorOfLayer1(state) {
    return Object.keys(state.forumSettings.layer1).map((key) => {
      return {
        val: key,
        txt: state.forumSettings.layer1[key].txt,
        sort: state.forumSettings.layer1[key].sort,
      }
    })
  },
  formSelectorOfLayer2(state) {
    const layer1Value = state.selectedForum.toString()[0]
    return Object.keys(state.forumSettings.layer2)
      .filter((key) => {
        return key.toString()[0] === layer1Value
            || (!!_isMobile() && key.toString()[0] === '5' && layer1Value === '1') // H5的世界杯在Du圈二級
            || (!!_isMobile() && key.toString()[0] === '1' && layer1Value === '5') // H5的Du圈二級導航也要在世界杯顯示
      })
      .map((key) => {
        return {
          val: key,
          txt: state.forumSettings.layer2[key].txt
        }
      })
  },
  isRouterFailRecallToMaxTimes(state) {
    const routerFailRecallCountMax = 1 // recall 次数上限
    return state.routerFailRecallCount >= routerFailRecallCountMax
  },
  // 判断是否当前页数已是最后一页
  // 可用来判断显示"点击加载更多(H5)", 或显示"页码(PC)"
  isForumListLoadedAll(state) {
    let isValid = false
    const page = +state.forumListData.page
    const pages = +state.forumListData.pages
    if (pages === 0 || page === pages) isValid = true
    const maxPage = state.forumSettings.layer2[state.selectedForum].maxPage || null
    if (maxPage && page === maxPage) isValid = true
    return isValid
  },
  // 判断是否当前页数已是最后一页
  // 可用来判断显示"点击加载更多(H5)", 或显示"页码(PC)"
  isHotBoardListLoadedAll(state) {
    let isValid = false
    const page = +state.hotBoardListData.page
    const pages = +state.hotBoardListData.pages
    if (pages === 0 || page === pages) isValid = true
    const maxPage = isH5View ? 8 : 1
    if (maxPage && page === maxPage) isValid = true
    return isValid
  }
}

const mutations = {
  setSelectedForum(state, data = '') {
    // console.log('!!!!!!!!!! set forum 2 !!!!!!!!!!!!!')
    state.selectedForum = data
  },
  setSelectedForumByLayer1(state, data = '') {
    // console.log('!!!!!!!!!! set forum 1 !!!!!!!!!!!!!')
    // A04BBS-1260 点击老哥和老姐，默认跳转最新页签
    state.selectedForum = data += (['2','3'].indexOf(data) > -1 ? '2' : '1')
  },
  setForumListData(state, data = {}) {
    state.forumListData = { ...state.forumListData, ...data } // 避免覆盖
  },
  setIsUpdateDataOnRouter(state, data = 0) {
    state.isUpdateDataOnRouter = data
  },
  setRouterFailRecallCount(state, data) {
    console.log('setRouterFailRecallCount', data)
    if (data) state.routerFailRecallCount = data
    else state.routerFailRecallCount++
  },
  setIsListDataLoading(state, data = false) {
    state.isListDataLoading = data
  },
  setHotBoardListData(state, data = {}) {
    state.hotBoardListData = { ...state.hotBoardListData, ...data } // 避免覆盖
  },
  clearForumListData(state, data = {}) {
    state.forumListData = {}
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
